<template>
  <div style="display: inline-block;margin-left: -13px; user-select: none;">
    <!-- :style="[{color: `${ color }`}]" -->
    <template>
      <div style="line-height: 32px;border-radius: 2px; border: 1px solid #E6E6E6;cursor: pointer; margin-top: 10px;display: inline-block; margin-left: 20px; position: relative;" v-for="(item, index) of fileData" :key="index" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
        ]">
        <slot></slot>
        <img :src="srcleft" style="width: 16px;height: 16px;vertical-align: middle;position: relative;margin-left: 10px;" />
        {{ item.FileName }}
        <a class="rightTitle Dowload" :style="[{color: `${ item.color }`}]" @click="DowloadFile(item.FileUrl , item.Extension)">
          <!-- {{
          item.Download
        }} -->
          查看
        </a>
        <img v-if="srcright" :src="srcright" style="width: 16px;height: 16px;vertical-align: middle;cursor: pointer;float: right;margin: 9px;" @click="closeFile(index)" />
      </div>
      <div :style="[{ width: `${opwidth}`, top: `${top}` }]" class="bodis" v-if="optional"></div>
    </template>
    <Picturepreview :show="showImg" :imgsrc="imgsrc" @hidefn="hidefn"></Picturepreview>
  </div>
</template>

<script>
import Picturepreview from '@/components/picturepreview.vue'
export default {
  components: {
    Picturepreview
  },
  props: {
    fileData: {
      type: Array,
    },
    //文字颜色
    color: {
      type: String,
      default: "#000",
    },
    // 按钮宽度
    width: {
      type: String,
      default: "100%",
    },
    // 按钮高度
    height: {
      type: String,
      default: "32px",
    },
    // 按钮文本
    title: {
      type: String,
      default: "",
    },
    // 文字大小
    fontSize: {
      type: String,
      default: "12px",
    },
    // 按钮背景色
    backgroundColor: {
      type: String,
      default: "#E6E6E6",
    },
    // icon路径
    srcright: {
      type: String,
      default: "",
    },
    srcleft: {
      type: String,
      default: "",
    },
    // 控制也用和禁用
    optional: {
      type: Boolean,
      default: false,
    },
    // 禁用蒙版的宽度
    opwidth: {
      type: String,
      default: "68px",
    },
    // 禁用蒙版的定位
    top: {
      type: String,
      default: "222px",
    },
    types: {
      type: String,
      default: "file",
    },
  },
  data: function () {
    return {
      showImg: false,
      imgsrc: ''
    }
  },
  created() { },
  mounted() { },
  methods: {
     hidefn() {
      this.showImg = false
    },
    // 删除文件
    closeFile(index) {
      this.fileData.splice(index, 1);
    },
    // 下载文件
    DowloadFile(URL, Extension) {
      if (Extension == 'jpg' || Extension == 'png' || Extension == 'gif') {
        this.showImg = true
        this.imgsrc = URL
      } else if (Extension == 'pdf'){
         window.open(URL, '_blank')
        // window.location.href = URL+"?response-content-type=application/octet-stream"
      } else {
        window.location.href = URL
      }
      this.$emit("DowloadFile");
    },
  },
};
</script>

<style lang="less">
.bodis {
  // width: 68px;
  height: 34px;
  opacity: 0.5;
  background-color: #ffffff;
  // background-color: red;
  position: absolute;
  // top: 216px;
  cursor: no-drop;
  //   position: relative;
  //   top: -416px;
  z-index: 1000;
}
.rightTitle {
  display: inline-block;
  float: right;
  margin-right: 20px;
  margin-top: -8px;
  text-decoration: underline;
}
</style>
